// Building the URL like this to avoid checkmarx issue
export const cdnURL = 'https' + '://' + 'cdn' + '.' + 'eurekacloud' + '.' + 'io';
